module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 7.e0112e64.png";